module.exports = __webpack_public_path__ + "img/4.05.thmb.fc5d5d71.jpg";